export default __webpack_public_path__ + "static/media/sregionsicon.b7ed9b7b.svg";